<template>
    <div class="dashboard-page page">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Dashboard</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div :key="index"
                 class="col-12 col-sm-6 col-lg-4 p-2"
                 v-for="(card, index) in cards"
                 v-if="hasRole(card.roles)">
                <router-link :to="{ name: card.route_name, query: card.route_query }"
                             class="card mini-stat card-bg card-link mb-0" tag="a">
                    <div class="card-body mini-stat-img">
                        <div class="mini-stat-icon" v-html="card.icon"></div>
                        <div class="text-white">
                            <h6 class="text-uppercase mb-3">{{ card.title }}</h6>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <div v-if="hasRole([Roles.admin, Roles.dealer_principle]) && user">
            <div class="row metrics">
                <div
                    :class="{ 'col-lg-3': hasRole(Roles.dealer_principle) || (hasRole(Roles.admin) && metric.order > 2)}"
                    class="col-12 col-sm-6 p-2"
                    v-if="metric.roles.includes(user.roles[0].name) && metric.order !== 11"
                    v-for="metric in metrics"
                >
                    <div class="card mini-stat card-bg">
                        <div class="card-body mini-stat-img">
                            <div class="mini-stat-icon"></div>
                            <div class="text-white">
                                <h6 class="text-uppercase mb-3">{{ metric.label }}</h6>
                                <h4 class="m-0" v-if="metric.is_money">{{ metric.value | currency }}</h4>
                                <h4 class="m-0" v-else>{{ metric.value }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Routes from "@/constants/routes";
import Route from "@/utils/route";
import Roles from "@/constants/roles";
import AuthUtils from "@/utils/auth";

export default {
    mounted() {
        if (AuthUtils.hasRole([Roles.admin, Roles.dealer_principle])) {
            this.initMetrics();
        }
    },
    data() {
        return {
            Roles,
            cards: [
                {
                        title: 'New Listing',
                        route_name: Routes.create_vehicle,
                        icon: `<i class="mdi mdi-plus float-right"/>`,
                        roles: Route.getRoles(Routes.create_vehicle)
                    },
                    {
                        title: 'Vehicle Search',
                        route_name: Routes.vehicle,
                        icon: `<i class="mdi mdi-magnify float-right"/>`,
                        roles: Route.getRoles(Routes.vehicle)
                    },
                    {
                        title: 'My Deals',
                        route_name: Routes.deal,
                        icon: `<i class="mdi mdi-handshake float-right"/>`,
                        roles: Route.getRoles(Routes.deal)
                    },
                    {
                        title: 'My Dealership Listings',
                        route_name: Routes.vehicle,
                        route_query: this.hasRole([Roles.dealer_principle, Roles.sales_manager])
                            ? {
                                dealership_listing_only: 1,
                                sold: 0,
                            }
                            : null,
                        icon: `<i class="mdi mdi-car float-right"/>`,
                        roles: Route.getRoles(Routes.vehicle)
                    }
                ],
                metrics: {
                    total_users: {
                        label: 'Total Users',
                        order: 1,
                        value: 0,
                        roles: [Roles.admin]
                    },
                    total_companies: {
                        label: 'Total Companies',
                        order: 2,
                        value: 0,
                        roles: [Roles.admin]
                    },
                    total_sales: {
                        label: 'Total Sales',
                        order: 3,
                        is_money: true,
                        value: 0,
                        roles: [Roles.admin, Roles.dealer_principle]
                    },
                    total_listings: {
                        label: 'Total Listing',
                        order: 4,
                        value: 0,
                        roles: [Roles.admin, Roles.dealer_principle]
                    },
                    average_days_listed: {
                        label: 'Average Days Listed',
                        order: 5,
                        value: 0,
                        roles: [Roles.admin, Roles.dealer_principle]
                    },
                    average_number_of_sales: {
                        label: 'Average Number of Sales',
                        order: 6,
                        value: 0,
                        roles: [Roles.admin, Roles.dealer_principle]
                    },
                    average_hold: {
                        label: 'Average Holds',
                        order: 7,
                        value: 0,
                        roles: [Roles.admin, Roles.dealer_principle]
                    },
                    average_view: {
                        label: 'Average Views',
                        order: 8,
                        value: 0,
                        roles: [Roles.admin, Roles.dealer_principle]
                    },
                    average_price: {
                        label: 'Average Listing Price',
                        is_money: true,
                        order: 9,
                        value: 0,
                        roles: [Roles.admin, Roles.dealer_principle]
                    },
                    average_days_to_be_sold: {
                        label: 'Average Days to be Sold',
                        order: 10,
                        value: 0,
                        roles: [Roles.admin, Roles.dealer_principle]
                    },
                },
            }
        },
        computed: {
            user() {
                return this.$store.state.user;
            }
        },
        methods: {
            initMetrics() {
                axios.get('/web-api/metrics')
                    .then((response) => {
                        _.forEach(this.metrics, (metric, key) => {
                            this.metrics[key]['value'] = response.data[key];
                        });
                    });
            }
        }
    }
</script>

<style scoped>
table th,
table td {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
</style>
